"use client";

import { c as _c } from "react/compiler-runtime";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import styles from "./DatePickerModal.module.scss";
interface Props {
  mode: "date" | "block";
  show: boolean;
  initial_from_date?: Date | undefined;
  initial_to_date?: Date | undefined;
  initial_from_block?: number | undefined;
  initial_to_block?: number | undefined;
  onApplyDate?: ((fromDate: Date, toDate: Date) => void) | undefined | undefined;
  onApplyBlock?: ((fromBlock: number, toBlock: number) => void) | undefined | undefined;
  onHide: () => void;
}
export default function DatePickerModal(props) {
  const $ = _c(74);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [fromBlock, setFromBlock] = useState("");
  const [toBlock, setToBlock] = useState("");
  const [error, setError] = useState();
  let t0;
  let t1;
  if ($[0] !== props.initial_from_date) {
    t0 = () => {
      if (props.initial_from_date) {
        setFromDate(props.initial_from_date.toISOString());
      }
    };
    t1 = [props.initial_from_date];
    $[0] = props.initial_from_date;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[3] !== props.initial_to_date) {
    t2 = () => {
      if (props.initial_to_date) {
        setToDate(props.initial_to_date.toISOString());
      }
    };
    t3 = [props.initial_to_date];
    $[3] = props.initial_to_date;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[6] !== props.initial_from_block) {
    t4 = () => {
      if (props.initial_from_block) {
        setFromBlock(props.initial_from_block.toString());
      }
    };
    t5 = [props.initial_from_block];
    $[6] = props.initial_from_block;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[9] !== props.initial_to_block) {
    t6 = () => {
      if (props.initial_to_block) {
        setToBlock(props.initial_to_block.toString());
      }
    };
    t7 = [props.initial_to_block];
    $[9] = props.initial_to_block;
    $[10] = t6;
    $[11] = t7;
  } else {
    t6 = $[10];
    t7 = $[11];
  }
  useEffect(t6, t7);
  let t8;
  if ($[12] !== fromDate || $[13] !== props || $[14] !== toDate) {
    t8 = function applyDate() {
      if (fromDate && toDate) {
        if (fromDate > toDate) {
          setError("The start date must be before the end date.");
          return;
        }
      }
      props.onApplyDate?.(new Date(fromDate), new Date(toDate));
      props.onHide();
    };
    $[12] = fromDate;
    $[13] = props;
    $[14] = toDate;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const applyDate = t8;
  let t9;
  if ($[16] !== fromBlock || $[17] !== props || $[18] !== toBlock) {
    t9 = function applyBlock() {
      const fromBlockInt = parseInt(fromBlock);
      const toBlockInt = parseInt(toBlock);
      if (isNaN(fromBlockInt) || isNaN(toBlockInt)) {
        setError("Please enter a valid start and end block.");
        return;
      }
      if (fromBlockInt > toBlockInt) {
        setError("The start block must be before the end block.");
        return;
      }
      props.onApplyBlock?.(fromBlockInt, toBlockInt);
      props.onHide();
    };
    $[16] = fromBlock;
    $[17] = props;
    $[18] = toBlock;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const applyBlock = t9;
  let t10;
  if ($[20] !== applyBlock || $[21] !== applyDate || $[22] !== props.mode) {
    t10 = function apply() {
      if (props.mode === "date") {
        applyDate();
      } else {
        applyBlock();
      }
    };
    $[20] = applyBlock;
    $[21] = applyDate;
    $[22] = props.mode;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const apply = t10;
  let t11;
  if ($[24] !== props) {
    t11 = () => props.onHide();
    $[24] = props;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== props.mode) {
    t12 = <Modal.Title>Select {props.mode}s</Modal.Title>;
    $[26] = props.mode;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== props) {
    t13 = <FontAwesomeIcon className={styles.modalClose} icon={faTimesCircle} onClick={() => props.onHide()} />;
    $[28] = props;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t12 || $[31] !== t13) {
    t14 = <div className={styles.header}>{t12}{t13}</div>;
    $[30] = t12;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== props.mode) {
    t15 = <Form.Label>Start {props.mode}</Form.Label>;
    $[33] = props.mode;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== fromBlock || $[36] !== fromDate || $[37] !== props.mode) {
    t16 = props.mode === "date" ? <Form.Control value={fromDate && new Date(fromDate)?.toISOString().slice(0, 10)} max={new Date().toISOString().slice(0, 10)} type="date" placeholder="Start Date" className={`${styles.formInput}`} onChange={e => {
      const value = e.target.value;
      if (value && value.length === 10) {
        const tempDate = new Date(value);
        if (!isNaN(tempDate.getTime())) {
          setFromDate(value);
        }
      } else {
        setFromDate("");
      }
    }} /> : <Form.Control value={fromBlock} className={`${styles.formInput}`} type="number" placeholder="Start Block" onChange={e_0 => {
      const value_0 = parseInt(e_0.target.value);
      if (isNaN(value_0)) {
        setFromBlock("");
      } else {
        setFromBlock(value_0.toString());
      }
    }} />;
    $[35] = fromBlock;
    $[36] = fromDate;
    $[37] = props.mode;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== t15 || $[40] !== t16) {
    t17 = <Form.Group className="mb-3">{t15}{t16}</Form.Group>;
    $[39] = t15;
    $[40] = t16;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== props.mode) {
    t18 = <Form.Label>End {props.mode}</Form.Label>;
    $[42] = props.mode;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== props.mode || $[45] !== toBlock || $[46] !== toDate) {
    t19 = props.mode === "date" ? <Form.Control value={toDate && new Date(toDate)?.toISOString().slice(0, 10)} max={new Date().toISOString().slice(0, 10)} className={`${styles.formInput}`} type="date" placeholder="End Date" onChange={e_1 => {
      const value_1 = e_1.target.value;
      if (value_1 && value_1.length === 10) {
        const tempDate_0 = new Date(value_1);
        if (!isNaN(tempDate_0.getTime())) {
          setToDate(value_1);
        }
      } else {
        setToDate("");
      }
    }} /> : <Form.Control value={toBlock} className={`${styles.formInput}`} type="number" placeholder="End Block" onChange={e_2 => {
      const value_2 = parseInt(e_2.target.value);
      if (isNaN(value_2)) {
        setToBlock("");
      } else {
        setToBlock(value_2.toString());
      }
    }} />;
    $[44] = props.mode;
    $[45] = toBlock;
    $[46] = toDate;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] !== t18 || $[49] !== t19) {
    t20 = <Form.Group className="mb-3">{t18}{t19}</Form.Group>;
    $[48] = t18;
    $[49] = t19;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  let t21;
  if ($[51] !== t17 || $[52] !== t20) {
    t21 = <Modal.Body className={`${styles.body} d-flex align-items-center justify-content-between font-larger`}><Container><Row><Col><Form>{t17}{t20}</Form></Col></Row></Container></Modal.Body>;
    $[51] = t17;
    $[52] = t20;
    $[53] = t21;
  } else {
    t21 = $[53];
  }
  let t22;
  if ($[54] !== error) {
    t22 = error && <span className="text-danger">{error}</span>;
    $[54] = error;
    $[55] = t22;
  } else {
    t22 = $[55];
  }
  let t23;
  if ($[56] !== t22) {
    t23 = <span>{t22}</span>;
    $[56] = t22;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  let t24;
  if ($[58] !== props) {
    t24 = <Button className="seize-btn-link" onClick={() => props.onHide()}>Cancel</Button>;
    $[58] = props;
    $[59] = t24;
  } else {
    t24 = $[59];
  }
  let t25;
  if ($[60] !== apply) {
    t25 = <Button className="seize-btn btn-white" onClick={() => {
      setError(undefined);
      apply();
    }}>Apply</Button>;
    $[60] = apply;
    $[61] = t25;
  } else {
    t25 = $[61];
  }
  let t26;
  if ($[62] !== t24 || $[63] !== t25) {
    t26 = <span className="d-flex justify-content-end gap-2">{t24}{t25}</span>;
    $[62] = t24;
    $[63] = t25;
    $[64] = t26;
  } else {
    t26 = $[64];
  }
  let t27;
  if ($[65] !== t23 || $[66] !== t26) {
    t27 = <Modal.Footer className={styles.footer}><Container><Row><Col className="d-flex justify-content-between gap-2">{t23}{t26}</Col></Row></Container></Modal.Footer>;
    $[65] = t23;
    $[66] = t26;
    $[67] = t27;
  } else {
    t27 = $[67];
  }
  let t28;
  if ($[68] !== props.show || $[69] !== t11 || $[70] !== t14 || $[71] !== t21 || $[72] !== t27) {
    t28 = <Modal show={props.show} onHide={t11}>{t14}{t21}{t27}</Modal>;
    $[68] = props.show;
    $[69] = t11;
    $[70] = t14;
    $[71] = t21;
    $[72] = t27;
    $[73] = t28;
  } else {
    t28 = $[73];
  }
  return t28;
}